<template>
    <b-modal ref="modal" :title="title" @hide="onCancel" @ok="onConfirm" ok-title="Apply"
        cancel-title="Cancel" :modal-class="parentModalClass">
        <b-form-group>
            <b-form-checkbox-group v-model="internalValue" :options="[]" stacked>
                <b-form-checkbox v-for="option in options" :key="option.value" :value="option.value">
                    <span class="key-color" :class="option.class"></span>{{ option.text }}
                </b-form-checkbox>
            </b-form-checkbox-group>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'PositionsModal',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            default: 'Select Positions'
        },
        parentModalClass: {
            type: String
        }
    },
    data() {
        return {
            internalValue: [...this.value]
        }
    },
    watch: {
        value(newVal) {
            this.internalValue = [...newVal]
        }
    },
    methods: {
        show() {
            this.$refs.modal.show()
        },
        hide() {
            this.$refs.modal.hide()
        },
        onConfirm() {
            this.$emit('confirm', this.internalValue)
        },
        onCancel() {
            this.internalValue = [...this.value]
        }
    }
}
</script>
